<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Basics/brand.html')">系统设置</div></el-breadcrumb-item>
			<el-breadcrumb-item>账户管理</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="btns">
			<el-button type="primary" size="small" @click="add" v-auth="['admin/user/add']">添加管理员</el-button>
		</div>
		<el-table :data="list" border>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>
			<el-table-column prop="username" label="账号"></el-table-column>
			<el-table-column prop="nick_name" label="昵称"></el-table-column>
			<el-table-column prop="email" label="邮箱"></el-table-column>
			<el-table-column prop="phone" label="手机号"></el-table-column>
			<el-table-column prop="real_name" label="真实姓名"></el-table-column>
			<el-table-column label="性别">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;line-height: 1.5;" v-if="scope.row.sex === 1">
						男
					</div>
					<div style="display: flex; align-items: center;line-height: 1.5;" v-else>
						女
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="type" label="类型">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;line-height: 1.5;" v-if="scope.row.status === 1">
						正常
					</div>
					<div style="display: flex; align-items: center;line-height: 1.5;" v-else-if="scope.row.status === 2">
						锁定
					</div>
				</template>
			</el-table-column>
			<el-table-column label="操作" min-width="200">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="edit(scope.row.id)" v-if="scope.row.id != 1" v-auth="['admin/user/edit']">编辑</el-button>
					<el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.id)" class="l10" v-if="scope.row.id != 1" v-auth="['admin/user/delete']">
						<el-button size="mini" type="danger" slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
export default {
	name: 'Menu',
	data() {
		return {
			list:[],
			isLoad:false,
			pageSize:20,
			total:0,
			page:1
		}
	},
	created() {
		this.loadList()
	},
	methods: {
		gotopage(url){
			var link =  this.$router.resolve({
				path: url
			});
			window.open(link.href, '_blank')
		},
		loadList(){
			if(this.isLoad)
				return
			this.isLoad = !this.isLoad
			this.axios.post('/admin/user/users',{
					page: this.page,
					limit: this.pageSize
			})
			.then(res => {
				this.isLoad = !this.isLoad
				this.list = res.data.list.data
				this.total = res.data.list.total
			})
			.catch(() => {
				this.isLoad = !this.isLoad
			})
		},
		add(){
			this.$router.push({ path: '/Settings/edit.html'});
		},
		// 传一个ID跳转到edit页面，进行编辑
		edit(id) {
			this.$router.push({
				path: '/Settings/edit.html',
				query: {
					id: id
				}
			});
		},
		assign(id,name) {
			this.$router.push({
				path: '/Settings/assign.html',
				query: {
					id: id,
					name: name
				}
			});
		},
		sizeReload(val){
			this.pageSize = val
			this.loadList()
		},
		pageReload(val){
			this.page = val
			this.loadList()
		},
		del(id) {
			if (this.isLoad) {
				return
			}
			this.isLoad = !this.isLoad
			// ajax删除 先将要删除数据的ID传过去  执行删除
			this.axios.delete('/admin/user/delete', {
				data: [
					id
				]
			})
			.then(() => {
				this.isLoad = !this.isLoad
				this.$message.success({
					message: '删除成功',
					showClose: false
				});
				// 重新获取数据
				this.loadList()
			})
			.catch(() => {
				this.isLoad = !this.isLoad
			})
		},
	}
}
</script>
<style>
</style>
